module.exports = new __parcel__URL__("snail.06380b65.svg").toString();